import Stack from "@mui/material/Stack";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/Button";

interface ModalFooterProps {
  onCancel: () => void;
  onSubmit: () => void;
  cancelKey: string;
  submitKey: string;
  isValid: boolean;
  isLoading: boolean;
  disabled?: boolean;
}

export const ModalFooter: React.FC<ModalFooterProps> = function ModalFooter({
  onCancel,
  onSubmit,
  cancelKey,
  submitKey,
  isValid,
  isLoading,
  disabled = false,
}) {
  const { t } = useTranslation();

  return useMemo(
    () => (
      <Stack direction="row" justifyContent="flex-end" gap="12px">
        <Button variant="plain" onClick={onCancel}>
          {t(cancelKey)}
        </Button>
        <Button
          variant="primary"
          onClick={onSubmit}
          disabled={!isValid || disabled}
          loading={isLoading}
        >
          {t(submitKey)}
        </Button>
      </Stack>
    ),
    [onCancel, onSubmit, cancelKey, submitKey, isValid, disabled, isLoading, t],
  );
};
